/* ============================================================
   NADS — Scoped Buy Box (inline, no iframe)
   Public API: NadsBuyBox.loadInto(hostEl, handle, previewThemeId)
     - fetches /products/{handle}?view=buybox  (server-rendered, metafield-aware)
     - extracts .NadsPdp__BuyBox + its component CSS, injects inline
     - hydrates all variants from /products/{handle}.js (no 250 cap)
     - binds swatch/pack/size -> variant -> price + pack qty + ATC price + perk
     - ATC -> /cart/add.js then fires product:added (Prestige opens the drawer)
   Faithful port of sections/nads-pdp-main.liquid buy-box logic, scoped to host.
   ============================================================ */
window.NadsBuyBox = (function () {
  var STYLED = false;

  function fmt(cents) {
    var f = window.NADS_MONEY_FORMAT || '${{amount}}';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, f); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function injectStyles(doc) {
    if (STYLED) return;
    STYLED = true;
    var nads = /Nads(BuyBox|Pdp|Swatch|Pack|Size|Atc|Form|Trust|Gifts|Mobile|Drawer|Modal)|nads-md-perk/;
    Array.prototype.forEach.call(doc.querySelectorAll('style'), function (st) {
      var t = st.textContent || '';
      if (nads.test(t) && !/shopify-section-group-header-group/.test(t)) {
        var s = document.createElement('style');
        s.setAttribute('data-nads-bb-css', '1');
        s.textContent = t;
        document.head.appendChild(s);
      }
    });
  }

  function fetchVariants(handle) {
    var all = [], seen = {};
    function page(p) {
      return fetch('/products/' + handle + '.js?page=' + p, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (!prod || !prod.variants || !prod.variants.length) return all;
          var added = 0;
          prod.variants.forEach(function (v) { if (!seen[v.id]) { seen[v.id] = 1; all.push(v); added++; } });
          if (added > 0 && p < 12) return page(p + 1);
          return all;
        })
        .catch(function () { return all; });
    }
    return page(1);
  }

  function wireOverlays(scope) {
    function openDrawer(id) {
      var d = document.getElementById(id); if (!d) return;
      d.setAttribute('aria-hidden', 'false'); d.classList.add('is-open'); document.body.style.overflow = 'hidden';
    }
    function closeDrawer(d) {
      if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      setTimeout(function () { document.body.style.overflow = ''; }, 340);
    }
    scope.addEventListener('click', function (e) {
      var open = e.target.closest && e.target.closest('[data-drawer-open]');
      if (open && scope.contains(open)) { e.preventDefault(); openDrawer(open.getAttribute('data-drawer-open')); return; }
      if (e.target.closest && e.target.closest('[data-drawer-close]')) { var dr = e.target.closest('.NadsDrawer'); if (dr) { closeDrawer(dr); return; } }
      var om = e.target.closest && e.target.closest('[data-action="open-modal"]');
      if (om) { e.preventDefault(); var m = document.getElementById(om.getAttribute('aria-controls')); if (m) m.setAttribute('aria-hidden', 'false'); return; }
      var cm = e.target.closest && e.target.closest('[data-action="close-modal"]');
      if (cm) { var md = cm.closest('.NadsModal'); if (md) md.setAttribute('aria-hidden', 'true'); return; }
      if (e.target.classList && e.target.classList.contains('NadsModal')) { e.target.setAttribute('aria-hidden', 'true'); }
    });
    if (!window.__nadsOverlayEsc) {
      window.__nadsOverlayEsc = true;
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.NadsDrawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
        document.querySelectorAll('.NadsModal[aria-hidden="false"]').forEach(function (m) { m.setAttribute('aria-hidden', 'true'); });
        document.body.style.overflow = '';
      });
    }
  }

  function bind(root, variants) {
    function getOpts() {
      var opts = [];
      for (var pos = 1; pos <= 3; pos++) {
        var r = root.querySelector('input[type="radio"][data-option-position="' + pos + '"]:checked');
        if (r) opts.push(r.value);
      }
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        var vo = [v.option1, v.option2, v.option3].filter(Boolean);
        return opts.every(function (o) { return vo.indexOf(o) >= 0; });
      }) || null;
    }
    function syncPrice(v) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-nads-price-list]'), function (pl) {
        var html;
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var sav = v.compare_at_price - v.price;
          html = '<span class="NadsBuyBox__WasPrice">' + fmt(v.compare_at_price) + '</span>' +
                 '<span class="NadsBuyBox__NowPrice">' + fmt(v.price) + '</span>' +
                 '<span class="NadsBuyBox__SavingsBadge" data-nads-savings-badge>YOU\'RE SAVING ' + fmt(sav) + '</span>';
        } else {
          html = '<span class="NadsBuyBox__NowPrice">' + fmt(v.price) + '</span>';
        }
        pl.innerHTML = html;
      });
    }
    function packQty() {
      var checked = root.querySelector('.NadsPackRadio:checked');
      if (!checked) return;
      var packSize = checked.getAttribute('data-pack-size') || '';
      var unitPrice = checked.getAttribute('data-unit-price') || '';
      var label = checked.getAttribute('data-pack-label') || '';
      var qtyEl = root.querySelector('[data-nads-qty-display]');
      var unitEl = root.querySelector('[data-nads-unit-price-display]');
      if (qtyEl) qtyEl.textContent = (packSize && packSize !== '0') ? packSize : label;
      if (unitEl) unitEl.textContent = unitPrice ? ('US ' + unitPrice.replace(' ea', '') + ' EACH') : '';
      Array.prototype.forEach.call(root.querySelectorAll('[data-nads-title-pack]'), function (tp) {
        var single = label.toLowerCase() === 'single' || parseInt(packSize, 10) === 1;
        tp.textContent = (!single && packSize && packSize !== '0') ? (' (' + packSize + ' PACK)') : '';
      });
    }
    function atcPrice(v) {
      var btn = root.querySelector('[data-atc-btn]');
      if (!btn) return;
      var pe = btn.querySelector('[data-atc-original-price]');
      if (pe) pe.textContent = '$' + (v.price / 100).toFixed(2);
    }
    function setId(v) {
      var form = root.querySelector('form[data-product-form]');
      if (!form) return;
      var inp = form.querySelector('input[name="id"]');
      if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'id'; form.appendChild(inp); }
      inp.value = v.id;
    }
    function perk(v) {
      var p = root.querySelector('.nads-md-perk[data-nads-perk]');
      if (!p) return;
      var pct = parseFloat(p.getAttribute('data-perk-pct'));
      if (isNaN(pct)) pct = 15;
      var disc = Math.round(v.price * (100 - pct) / 100);
      var sav = v.price - disc;
      var pe = p.querySelector('[data-perk-price]');
      var se = p.querySelector('[data-perk-savings]');
      var ee = p.querySelector('[data-perk-extra]');
      if (pe) pe.textContent = fmt(disc);
      if (se) se.textContent = fmt(sav) + ' today';
      if (ee) ee.style.display = (v.compare_at_price && v.compare_at_price > v.price) ? '' : 'none';
    }
    function update() {
      var opts = getOpts();
      if (!opts.length) return;
      var v = findVariant(opts);
      if (!v) return;
      syncPrice(v); packQty(); atcPrice(v); setId(v); perk(v);
      var btn = root.querySelector('[data-atc-btn]');
      if (btn) { if (v.available) btn.removeAttribute('disabled'); else btn.setAttribute('disabled', 'disabled'); }
    }

    function imgSrc(v, size) {
      var f = v.featured_image;
      var raw = !f ? '' : (typeof f === 'string' ? f : (f.src || ''));
      if (!raw || !size) return raw;
      var out = raw.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)(\.\w+)/, '_' + size + '$2');
      if (out === raw) out = raw.split('?')[0].replace(/(\.\w+)$/, '_' + size + '$1');
      return out;
    }
    function selColor() { var c = root.querySelector('.NadsSwatch__Radio:checked'); return c ? c.value : null; }
    function selPack() { var p = root.querySelector('.NadsPackRadio:checked'); return p ? { num: p.getAttribute('data-pack-size') || '', value: p.value || '' } : null; }
    function colorMatch(v, color) { return v.option1 === color || v.option2 === color || v.option3 === color; }
    function packMatch(v, pk) {
      if (!pk) return true;
      if (pk.value && (v.option1 === pk.value || v.option2 === pk.value || v.option3 === pk.value)) return true;
      if (pk.num) {
        var ns = pk.num + ' Pack';
        if ((v.option1 && v.option1.indexOf(ns) >= 0) || (v.option2 && v.option2.indexOf(ns) >= 0) || (v.option3 && v.option3.indexOf(ns) >= 0)) return true;
      }
      if (pk.value === 'Single' || pk.num === '1') {
        if (v.option1 === 'Single' || v.option2 === 'Single' || v.option3 === 'Single') return true;
      }
      return false;
    }
    function matchCP(color, pk) {
      var i, v;
      for (i = 0; i < variants.length; i++) { v = variants[i]; if (v.featured_image && colorMatch(v, color) && packMatch(v, pk)) return v; }
      for (i = 0; i < variants.length; i++) { v = variants[i]; if (v.featured_image && colorMatch(v, color)) return v; }
      return null;
    }
    function galSwitch(target) {
      Array.prototype.forEach.call(root.querySelectorAll('.NadsGallery__Slide'), function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === target); });
      Array.prototype.forEach.call(root.querySelectorAll('.NadsGallery__Thumb'), function (t) { t.classList.toggle('is-active', t.getAttribute('data-target') === target); });
    }
    function syncHero() {
      var color = selColor(); if (!color) return;
      var m = matchCP(color, selPack());
      var thumb = root.querySelector('#nads-variant-thumb'), slide = root.querySelector('#nads-variant-slide'), mslide = root.querySelector('#nads-mobile-variant-slide');
      var src = m ? imgSrc(m, '800x') : '';
      if (!src) {
        if (thumb) thumb.style.display = 'none';
        if (slide) slide.style.display = 'none';
        if (mslide) mslide.style.display = 'none';
        return;
      }
      if (thumb) thumb.style.display = '';
      if (mslide) mslide.style.display = '';
      var hi = root.querySelector('#nads-variant-hero-img'); if (hi) hi.src = src;
      var ti = root.querySelector('#nads-variant-thumb-img'); if (ti) ti.src = imgSrc(m, '160x200');
      var mi = root.querySelector('#nads-mobile-variant-img'); if (mi) mi.src = src;
      galSwitch('variant-hero');
    }
    function syncSwatchImages() {
      var pk = selPack(); if (!pk) return;
      Array.prototype.forEach.call(root.querySelectorAll('.NadsSwatch__Radio'), function (radio) {
        var item = radio.closest('.NadsSwatchItem'); if (!item) return;
        var img = item.querySelector('.NadsImgSwatch img'); if (!img) return;
        var v = matchCP(radio.value, pk);
        if (v) { var ns = imgSrc(v, '160x200'); if (ns && img.src !== ns) img.src = ns; }
      });
    }
    function syncThumbHeight() {
      var main = root.querySelector('.NadsGallery__Main'), thumbs = root.querySelector('.NadsGallery__Thumbs');
      if (main && thumbs && main.offsetHeight) { thumbs.style.maxHeight = main.offsetHeight + 'px'; thumbs.style.overflowY = 'auto'; }
    }

    root.addEventListener('change', function (e) {
      var t = e.target; if (!t) return;
      var isColor = t.classList.contains('NadsSwatch__Radio') || t.classList.contains('NadsSwatch__Radio--push');
      var isPack = t.classList.contains('NadsPackRadio');
      if (isColor || isPack || t.classList.contains('NadsSize__Radio')) {
        update();
        if (isPack) syncSwatchImages();
        if (isColor || isPack) syncHero();
      }
    });

    root.addEventListener('click', function (e) {
      var thumb = e.target && e.target.closest('.NadsGallery__Thumb');
      if (thumb) { galSwitch(thumb.getAttribute('data-target')); return; }
      var btn = e.target && e.target.closest('form[data-product-form] [data-atc-btn]');
      if (!btn) return;
      e.preventDefault();
      var form = btn.closest('form[data-product-form]');
      if (!form) return;
      var fd = new FormData(form);
      var id = parseInt(fd.get('id'), 10);
      if (!id) return;
      var item = { id: id, quantity: parseInt(fd.get('quantity') || '1', 10) };
      btn.setAttribute('disabled', 'disabled');
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        btn.removeAttribute('disabled');
        if (r.ok) {
          document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: { id: item.id }, quantity: item.quantity } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      }).catch(function () { btn.removeAttribute('disabled'); });
    });

    // #5 — kill the dead "pairs sold" link UX → plain text
    var sold = root.querySelector('.NadsBuyBox__SoldBadge');
    if (sold) {
      var span = document.createElement('span');
      span.className = 'NadsBuyBox__SoldBadge';
      span.textContent = sold.textContent;
      span.style.cssText = 'background:none;border:0;padding:0;margin:0;cursor:default;text-decoration:none;color:inherit;';
      sold.parentNode.replaceChild(span, sold);
    }
    // #2/#3 — wire ALL drawers (accordions + size guide) and modals to the theme's open/close behaviour
    wireOverlays(root);
    syncHero();                              // #2 — populate the selected-variant slot on load
    requestAnimationFrame(syncThumbHeight);  // #1 — clamp thumb column to main-image height
    setTimeout(syncThumbHeight, 250);
    var hero0 = root.querySelector('#nads-variant-hero-img'); if (hero0) hero0.addEventListener('load', syncThumbHeight);
    window.addEventListener('resize', syncThumbHeight);
    update();
  }

  function loadInto(host, handle, pv) {
    host.innerHTML = '<div style="padding:48px;text-align:center;opacity:.45;font-size:14px;">Loading…</div>';
    var url = '/products/' + handle + '?view=buybox' + (pv ? '&preview_theme_id=' + encodeURIComponent(pv) : '');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var bb = doc.querySelector('.NadsPdp__Container') || doc.querySelector('.NadsPdp__BuyBox');
        if (!bb) { host.innerHTML = '<div style="padding:48px;text-align:center;opacity:.6;">Couldn\u2019t load this product.</div>'; return; }
        injectStyles(doc);
        host.innerHTML = '';
        host.setAttribute('data-nads-handle', handle);
        host.appendChild(bb);
        // #2/#3 — bring every drawer + modal along (accordion rows + size guide live outside the container)
        doc.querySelectorAll('.NadsDrawer, .NadsModal').forEach(function (el) { host.appendChild(el); });
        fetchVariants(handle).then(function (vs) { bind(host, vs); });
      })
      .catch(function () { host.innerHTML = '<div style="padding:48px;text-align:center;opacity:.6;">Couldn\u2019t load this product.</div>'; });
  }

  return { loadInto: loadInto };
})();
